import IconMinus from "./icon-minus";
export default IconMinus;